(function($){

	$(window).on('load',function(){
		AOS.init();
	});
	
	
})(jQuery);